import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=47c99fc8"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c99fc8')) {
      api.createRecord('47c99fc8', component.options)
    } else {
      api.reload('47c99fc8', component.options)
    }
    module.hot.accept("./Person.vue?vue&type=template&id=47c99fc8", function () {
      api.rerender('47c99fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Card/Person.vue"
export default component.exports